<template>
    <div class="mt-2 mb-4">
        <SearchInput @handleInput="(value) => (userInput = value)" />
        <AddButton @click="() => emits('handleChangeState')" />
    </div>

    <ContactList
        @handleContactClick="handleStartNewChat"
        :isLoading="loadingState.startChat"
        :searchQuery="userInput"
    />
</template>

<script setup>
import AddButton from "../../../AddButton.vue";
import SearchInput from "../../SearchInput.vue";
import ContactList from "./ContactList.vue";
import { socketConn } from "@/stores/socketConn";
import { useChatStore } from "@/stores/chatStore";
import useToggleModal from "@/composables/useToggleModal";
import { Toast } from "@/composables/Toast";
import { onMounted, ref } from "vue";
import { groupMembers } from "./globalStates";

const emits = defineEmits(["handleChangeState"]);

// [info]: states
const userInput = ref("");

// [info]: composable
const { loadingState, handleCreateRoom, handleFetchAllChats, getMemberDetailFromNode } = useChatStore();
const { toggleModal } = useToggleModal();
const { showToast } = Toast();

// [info]: methods
const handleStartNewChat = async (contact) => {
    if (!contact) return;
    try {
        loadingState.startChat = true;
        const data = await getMemberDetailFromNode(contact);
        if (data) {
            socketConn.socket.emit("contact registerd");
            // [info]: i do not think we need this. As far as i understand this is just to trigger the watch on inbox
            // selectedContact.contactId = data?._id;
            await handleCreateRoom(data?._id);
            await handleFetchAllChats(null, true);
            showToast("Success", "Success", 'Chat Initiated Successfully!');
            toggleModal("new_message");
        }
    } catch (e) {
        console.error("[ERR]: at starting a new chat with contact", e);
    } finally {
        loadingState.startChat = false;
    }
};

onMounted(() => {
    groupMembers.value = [];
});
</script>
